const TEXT_FIELD_ICON_CLASS_NAME = 'text-field-icon';
const DEFAULT_ICON_CLASS_NAME = 'default-icon';
const SECONDARY_ICON_CLASS_NAME = 'secondary-icon';
const CONFIRMATION_ICON_CLASS_NAME = 'confirmation-icon';
const NAVBAR_ICON_CLASS_NAME = 'navbar-icon';
const CARD_CORNER_ICON_CLASS_NAME = 'card-corner-icon';

export {
  TEXT_FIELD_ICON_CLASS_NAME,
  DEFAULT_ICON_CLASS_NAME,
  SECONDARY_ICON_CLASS_NAME,
  CONFIRMATION_ICON_CLASS_NAME,
  NAVBAR_ICON_CLASS_NAME,
  CARD_CORNER_ICON_CLASS_NAME,
};
